import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'post'

export default class OspreyImagesCreate extends BaseAction {
    constructor(dataKey) {
        const id = 'bda0db36-ea34-485e-9824-f8660c3e113a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    create(params) {
        this.path = `/${resource}`
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-create.js